// removed by extract-text-webpack-plugin
module.exports = {"mask":"_316XKMq2f4QLn_NBqVv4Ch","text":"_3VgL1BYAvPyt5LfXPzjtNT"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Banner/AgeOf/styles.scss
 ** module id = 446
 ** module chunks = 0
 **/